// Intercept identitytoolkit/securetoken API calls in dev/test mode to prevent crashes from mock Firebase credentials.
if (import.meta.env.VITE_DEV_AUTH_BYPASS === 'true' && typeof window !== 'undefined') {
  const originalFetch = window.fetch;
  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : (input as Request).url || '';
    if (url.includes('identitytoolkit.googleapis.com') || url.includes('securetoken.googleapis.com')) {
      return new Response(JSON.stringify({
        users: [],
        kind: "identitytoolkit#GetAccountInfoResponse"
      }), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    }
    return originalFetch.apply(this, arguments as any);
  };

  const originalOpen = window.XMLHttpRequest.prototype.open;
  const originalSend = window.XMLHttpRequest.prototype.send;
  window.XMLHttpRequest.prototype.open = function (method, url) {
    this._url = typeof url === 'string' ? url : url.toString();
    return originalOpen.apply(this, arguments as any);
  };
  window.XMLHttpRequest.prototype.send = function (body) {
    if (this._url && (this._url.includes('identitytoolkit.googleapis.com') || this._url.includes('securetoken.googleapis.com'))) {
      Object.defineProperty(this, 'status', { writable: true, value: 200 });
      Object.defineProperty(this, 'readyState', { writable: true, value: 4 });
      Object.defineProperty(this, 'responseText', {
        writable: true,
        value: JSON.stringify({
          users: [],
          kind: "identitytoolkit#GetAccountInfoResponse"
        })
      });
      if (this.onreadystatechange) {
        this.onreadystatechange(new Event('readystatechange'));
      }
      if (this.onload) {
        this.onload(new Event('load'));
      }
      return;
    }
    return originalSend.apply(this, arguments as any);
  };
}

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from '@/src/modules/auth/AuthProvider';
import { PreferencesProvider } from '@/src/modules/preferences/PreferencesProvider';
import App from './App.tsx';
import './i18n'; // bootstraps i18next before any component renders
import './index.css';
import { initSentry } from '@/src/infrastructure/lib/sentry';
import { initAnalytics } from '@/src/infrastructure/lib/analytics';

// Load GA4 (no-op unless VITE_GA_MEASUREMENT_ID is a valid G-XXXX id).
initAnalytics();

function renderApp() {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <HelmetProvider>
        <PreferencesProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </PreferencesProvider>
      </HelmetProvider>
    </StrictMode>,
  );
}

// Initialize Sentry before rendering so startup/render errors are not lost.
void initSentry().finally(renderApp);
